<template>
  <b-modal
    ref="modal-dealsheet-include-imeis"
    title="Nhập danh sách IMEI phát sinh từ excel"
    size="lg"
  >
    <div class="row">
      <div class="col-md-12">
        <ExcelImport
          :url-excel="urlExcel"
          :cancel-route="'/deal-sheets'"
          :uploading="uploading"
          :file="file"
          :disabled="hasValidationErrors"
          :hide-wrapper="true"
          @file-select="handleFileSelect"
          @clear-file="handleClearFile"
        >
          <template #table>
            <ExcelImportListTable
              table-title="Danh sách IMEI phát sinh"
              :items="importItems"
              :fields="fields"
              :uploading="uploading"
              :valid-count="validCount"
              :invalid-count="invalidCount"
              :current-page="currentPage"
              show-status-tabs
              @update:currentPage="currentPage = $event"
            />
          </template>
        </ExcelImport>
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="hideModal">Hủy</b-button>
      <SaveButton
        :is-busy="uploading"
        :disabled="!canSave"
        @click="handleSubmit"
      />
    </template>
  </b-modal>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ExcelImport from '@/view/components/common/ExcelImport.vue';
import ExcelImportListTable from '@/view/components/common/ExcelImportListTable.vue';
import excelImportMixin from '@/view/mixins/excel-import.mixin';
import { URL_IMPORT_DEALSHEET_INCLUDE_IMEIS } from '@/utils/constants';
import SaveButton from '@/view/components/common/SaveButton.vue';
import { showConfirmNotify } from '@/utils/sweet-alert2';
import { makeToastFaile } from '@/utils/common';

export default {
  name: 'ImportDealSheetIncludeImeisModal',
  mixins: [excelImportMixin],
  components: {
    ExcelImport,
    ExcelImportListTable,
    SaveButton,
  },
  data() {
    return {
      urlExcel: URL_IMPORT_DEALSHEET_INCLUDE_IMEIS,
      dealSheetId: null,
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'imeiCode',
          label: 'Mã IMEI',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '25%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'note',
          label: 'Ghi chú',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '25%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'errors',
          label: 'Chi tiết',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-left',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dealsheet', route: '/deal-sheets' },
      {
        title: 'Chi tiết dealsheet',
        route: '/deal-sheets',
      },
      { title: 'Nhập IMEI phát sinh từ excel' },
    ]);
  },
  methods: {
    mapExcelDataToItems(excelData) {
      return excelData.map((element) => ({
        imeiCode: element['IMEI'],
        note: element['Ghi chú'],
        isValid: true,
        errors: [],
      }));
    },
    getValidationEndpoint() {
      return 'v1/deal-sheets/valid-import-include-imeis';
    },
    getValidationPayload(importItems) {
      return {
        includeImeis: importItems.map((item) => ({
          imeiCode: item.imeiCode?.trim(),
          note: item.note?.trim(),
        })),
      };
    },
    getSubmitEndpoint() {
      return null;
    },
    async handleSubmit() {
      const validImeis = this.importItems.filter((item) => item.isValid);
      const skippedCount = this.importItems.length - validImeis.length;

      if (validImeis.length === 0) {
        makeToastFaile('Không có IMEI hợp lệ nào để lưu');
        return;
      }

      // Còn IMEI không hợp lệ → xác nhận bỏ qua trước khi lưu
      if (skippedCount > 0) {
        const result = await showConfirmNotify({
          title: 'Xác nhận bỏ qua IMEI không hợp lệ',
          html:
            `Có <b class="text-danger">${skippedCount}</b> IMEI không hợp lệ sẽ bị <b>bỏ qua</b>.<br/>` +
            `Hệ thống sẽ chỉ lưu <b class="text-success">${validImeis.length}</b> IMEI hợp lệ. Bạn có muốn tiếp tục?`,
          actionName: 'Tiếp tục lưu',
          confirmButtonColor: '#3699FF',
        });
        if (!result.isConfirmed) {
          return;
        }
      }

      this.$emit('update-include-imeis', validImeis);
      this.hideModal();
      this.clearFiles();
    },
    getSubmitPayload() {
      return {
        includeImeis: this.importItems.filter((item) => item.isValid),
      };
    },
    handleClearFile() {
      this.clearFiles();
    },
    hideModal() {
      this.$refs['modal-dealsheet-include-imeis'].hide();
    },
    showModal(dealSheetId = null) {
      this.dealSheetId = dealSheetId;
      this.$refs['modal-dealsheet-include-imeis'].show();
    },
  },
  computed: {
    canSave() {
      // Cho phép lưu khi có ít nhất 1 IMEI hợp lệ; IMEI sai sẽ được bỏ qua (có xác nhận)
      return this.validCount > 0;
    },
  },
};
</script>
